import { CONTENT_TYPES, FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import I18n from 'I18n';
import { Select } from 'foundations-components/components/Select';
import { FiltersWrapper } from './FiltersWrapper';
import { useHasGate } from '../../accounts/accountsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = () => CONTENT_TYPES.map(contentType => ({
  text: I18n.text(`academyComponents.topFilters.contentType.${contentType}`),
  value: contentType
}));
export const AllContentTypesFilter = ({
  appearsIn,
  excludeTypes = []
}) => {
  const [contentTypes, setContentTypes] = useSearchParam(FILTER_TYPES.CONTENT_TYPE);
  const {
    hasGate: hasLiveEventGate
  } = useHasGate('AcademyAchievements::MyLearningSearchLiveEventRollout');
  const effectiveExcludeTypes = hasLiveEventGate ? excludeTypes : [...excludeTypes, 'LIVE_EVENT'];
  const handleAllContentTypesChange = selectedTypes => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: selectedTypes.length ? 'filter-selected' : 'filter-deselected',
      value: selectedTypes,
      isDropdown: true,
      key: 'all-content-types-filter',
      appearsIn
    });
    setContentTypes(selectedTypes);
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      "aria-label": I18n.text('academyComponents.topFilters.contentType.filterTitle'),
      clearable: true,
      "data-test-id": "filter-type-contentType",
      menuInlineSize: 200,
      menuMaxBlockSize: 400,
      multi: true,
      onSelectedOptionChange: evt => {
        handleAllContentTypesChange(evt.selectedValues);
      },
      options: getOptions().filter(option => !effectiveExcludeTypes.includes(option.value)),
      selectedItemsPlaceholder: I18n.text('academyComponents.topFilters.contentType.filterTitle'),
      selectedValues: contentTypes
    })
  });
};